import {AccountType, MetaData} from "@qid/core";
import {AccountAttribute} from "../../account-attribute/model/account-attribute.model";

export class AccountProfile extends MetaData {

  account_id: string;

  accountType: AccountType;

  displayPictureUrl: string;

  name: AccountAttribute;

  bio: string;

  defaultAccountAttributes: AccountAttribute[]

  constructor() {
    super();
  }
}



